import FVector from '@data/geometry/FVector';
import * as THREE from 'three';
import { SensorData } from 'Simulations/SensorPoint';
import { Facade } from './Facade';
import { isEdgeFacing } from './FacadeVisibility';

/**
 * Transparent only when the edge faces the resolved direction.
 */
export class TransparentMainDirectionFacade extends Facade {
    private readonly transparentMaterial: THREE.Material;
    private readonly opaqueMaterial: THREE.Material;
    private readonly perimeter: FVector[];
    private readonly visibilityLoops: FVector[][];

    constructor(
        p1: FVector,
        p2: FVector,
        height: number,
        transparentMaterial: THREE.Material,
        opaqueMaterial: THREE.Material,
        perimeter: FVector[],
        visibilityLoops: FVector[][],
        sensors?: SensorData[],
        direction?: FVector
    ) {
        super(p1, p2, height, opaqueMaterial, sensors, direction);
        this.transparentMaterial = transparentMaterial;
        this.opaqueMaterial = opaqueMaterial;
        this.perimeter = perimeter;
        this.visibilityLoops = visibilityLoops;
    }

    override build(): THREE.Group {
        const direction = this.getFacadeDirection();
        const isFacing =
            !!direction && !FVector.isZero(direction) && isEdgeFacing(this.p1, this.p2, this.perimeter, direction, this.visibilityLoops);

        return this.buildFacadeQuad(
            this.p1,
            this.p2,
            this.height,
            isFacing ? this.transparentMaterial : this.opaqueMaterial,
            TransparentMainDirectionFacade.edgeMaterial
        );
    }
}
